import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './contribution_prefs.less'

import MoneyTextBox from 'components/common/money_text_box'
import RadioWithContent from 'components/common/radio_with_content'
import { getI18n } from 'client/i18n'

import { AMOUNT_TYPES } from '../../../shared/shared_consts'

const i18n = getI18n('components/contribution_prefs')

export function validateFunc(goal) {
  return function validate(values) {
    const errors = {}
    const requiredError = i18n('required')
    const moreThanGoalError = i18n('more_than_goal')

    if (values.amountType === AMOUNT_TYPES.exactly) {
      if (!values.amountExactly) {
        errors.amountExactly = requiredError
      }
      if (values.amountExactly > goal) {
        errors.amountExactly = moreThanGoalError
      }
    } else if (values.amountType === AMOUNT_TYPES.at_least) {
      if (!values.amountAtLeast) {
        errors.amountAtLeast = requiredError
      }
      if (values.amountAtLeast > goal) {
        errors.amountAtLeast = moreThanGoalError
      }
    }
    return errors
  }
}

class ContributionPrefs extends React.Component {
  static displayName = 'ContributionPrefs'

  static propTypes = {
    // These should be redux-form's fields.
    amountType: PropTypes.any.isRequired,
    amountAtLeast: PropTypes.any.isRequired,
    amountExactly: PropTypes.any.isRequired,

    // This should be react-redux's untouch() function given by the props it passes to the form component
    untouch: PropTypes.func.isRequired,
    shouldAutoFocus: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange() {
    this.props.untouch(
      this.props.amountAtLeast.name,
      this.props.amountExactly.name
    )
    this.props.amountType.onChange(...arguments)
  }

  render() {
    let { amountType, amountAtLeast, amountExactly } = this.props

    return (
      <div>
        <div styleName="radio-wrapper">
          <RadioWithContent
            id="radio-any"
            value={AMOUNT_TYPES.any}
            onChange={this.handleChange}
            name={amountType.name}
            fieldValue={amountType.value}
            label={i18n('any')}
            autoFocus={this.props.shouldAutoFocus}
            dataNemo="radio-any-amount"
          />
        </div>

        <div styleName="radio-wrapper">
          <RadioWithContent
            id="radio-at-least"
            value={AMOUNT_TYPES.at_least}
            onChange={this.handleChange}
            name={amountType.name}
            fieldValue={amountType.value}
            label={i18n('at_least')}
            dataNemo="radio-atleast-amount"
          >
            <MoneyTextBox
              dataNemo="minAmountValue"
              data-pa-focus="minAmountValue"
              title={i18n('enter_amount')}
              {...amountAtLeast}
            />
          </RadioWithContent>
        </div>

        <div styleName="radio-wrapper">
          <RadioWithContent
            id="radio-exactly"
            value={AMOUNT_TYPES.exactly}
            onChange={this.handleChange}
            name={amountType.name}
            fieldValue={amountType.value}
            label={i18n('exactly')}
            dataNemo="radio-exact-amount"
          >
            <MoneyTextBox
              dataNemo="exactAmountValue"
              data-pa-focus="exactAmountValue"
              title={i18n('enter_amount')}
              {...amountExactly}
            />
          </RadioWithContent>
        </div>
      </div>
    )
  }
}

export default cssModules(ContributionPrefs, styles)
